import { RenderWithBuilder } from "@faire/builder-core/BuilderComponents/RenderWithBuilder";
import { SignUpType } from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import qs from "query-string";
import { useLocation } from "react-router-dom";

export const BuilderProductGridInlineBanner: React.FC<{
  onViewEvent?: () => void;
}> = ({ onViewEvent }) => {
  const location = useLocation();
  return (
    <RenderWithBuilder
      onViewEvent={onViewEvent}
      modelName="discover-sign-up-banner"
      data={{
        signupUrl: `${location.pathname}?${qs.stringify({
          ...qs.parse(location.search),
          signUp: SignUpType.GENERIC,
        })}`,
      }}
    />
  );
};
